import { HSLColor } from '@yola/yola-palette-generator';
import parseHslaColorString from './parse-hsla-color-string';
import parseHslColorString from './parse-hsl-color-string';

const parseColor = (color) =>
  color.includes('hsla') ? parseHslaColorString(color) : parseHslColorString(color);

// Accepts an HSLColor instance or a CSS hsl/hsla string. Returns an HSLColor.
export const parseColorInput = (value) => {
  if (typeof value === 'string') {
    const { h, s, l, a } = parseColor(value);
    return new HSLColor(h, s, l, a);
  }
  return value;
};

export const parseColorMap = (colors) =>
  Object.fromEntries(Object.entries(colors).map(([key, val]) => [key, parseColorInput(val)]));

export const normalizeSchemes = (schemes, variableDefinitions = {}) =>
  Object.fromEntries(
    Object.entries(schemes).map(([id, scheme]) => {
      const normalized = { ...scheme };
      if (normalized.baseColor) {
        normalized.baseColor = parseColorInput(normalized.baseColor);
      }
      if (normalized.variableOverrides) {
        normalized.variableOverrides = Object.fromEntries(
          Object.entries(normalized.variableOverrides).map(([varName, val]) => [
            varName,
            variableDefinitions[varName]?.outputModes.includes('string')
              ? val
              : parseColorInput(val),
          ])
        );
      }
      return [id, normalized];
    })
  );
